import React, { useRef, useState } from "react";
import { Card, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useShortenUrl } from "react-shorten-url";
import {
  marDiscountCode,
  marDiscountCodeMsg,
} from "../../settings/About/AboutUtils";
import { CopyToClip } from "../../utils/copy.utils";

export function SetItem({ title, available, rent, permonth, image, link, id }) {
  const tableRef = useRef(null);
  //const [copySuccess, setCopySuccess] = useState("");
  //const marCoupon = "../../img/coupon_mar_bw.jpg";
  const user = useSelector((state) => state.auth.user);
  const [isCopied, setIsCopied] = useState(false);
  const [copiedValue, setCopiedValue] = useState("");

  // const copyToClipboard = (e) => {
  //   const code = tableRef.current.innerHTML;
  //   console.log("code", code);
  //   document.execCommand("copy");
  //   e.target.focus();
  //   setCopySuccess("Copied!");
  // };

  const { loading, error, data } = useShortenUrl(`${link}`);
  if (loading) {
    return "loading...";
  }
  if (error) {
    return "Something went wrong...";
  }

  return (
    <div
      id="textToCopy"
      className="text-center mb-1 mr-1 "
      style={{ maxWidth: "21rem" }}
      ref={tableRef}
    >
      <Card border="info">
        {image && (
          <Card.Img
            style={{ height: "15rem", objectFit: "cover" }}
            variant="top"
            className="img-fluid"
            alt="room_image"
            src={image && image}
          />
        )}
        {!image && (
          <Card.Header>
            <h4 className="mt-3 text-center text-info">
              GET 15% DISCOUNT ON BOOKING FEES - SPOTAHOME WEBSITE
            </h4>
            <h1
              className="lead text-center bg-info border text-white border-warning b-5 m-5 p-2 shadow"
              style={{
                verticalAlign: "middle",
                textAlign: "center",
                alignContent: "center",
                fontSize: "50px",
                fontWeight: "bold",
              }}
            >
              {marDiscountCode}
            </h1>
            <p className="text-center">
              <em>{marDiscountCodeMsg}</em>
            </p>
          </Card.Header>
        )}
        <Card.Body>
          <Card.Title>
            <span role="img" aria-label="">
              📢
            </span>
            {""}
            {title && title.toUpperCase()}
          </Card.Title>
          <Card.Text>
            <span role="img" aria-label="">
              🕘{""}
            </span>{" "}
            {available}{" "}
            <span role="img" aria-label="">
              💶
              {rent}
              {permonth}
            </span>{" "}
            <span>
              count:{"   "}
              <strong> {id && id}</strong>
            </span>
          </Card.Text>
          <Card.Footer>
            <Card.Body>
              <Card.Link
                href={data && data.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <span role="img" aria-label="">
                  🔗 👉{" "}
                </span>
                {data && data.link}
              </Card.Link>
              {image && user.role === "admin" && (
                <Card.Link href={image} download>
                  download
                </Card.Link>
              )}
              {/* {
      
       // Logical shortcut for only displaying the 
        //  button if the copy command exists 
        document.queryCommandSupported("copy") && (
          <div>
            <button onClick={copyToClipboard}>Copy</button>
            {copySuccess}
          </div>
        )
      }  */}

              <CopyToClip
                value={`
                        📢${title && title.toUpperCase()}\n
                        🕘 ${available}\n
                        💶 ${rent} ${permonth}\n
                        count: ${id && id} \n 
                        🔗👉 ${data && data.link}\n \n
                        📝 *We help you to find 🏠rooms, studios, apartments in majors Europeans cities... Check other properties in #paris, #brussels, #london, #berlin,#dublin, #barcelona, #madrid...* 
                        🔗 👉  https://bit.ly/36W88xX \n 
                        Use FBMARIUS15 to have 15% discount on reservation fees \n 
                        💬 🇬🇧🇫🇷`}
                isCopied={isCopied}
                onCopy={() => setIsCopied(true)}
                onChange={(copiedValue) => {
                  setIsCopied(false);
                  setCopiedValue(copiedValue);
                }}
              />
            </Card.Body>
          </Card.Footer>
        </Card.Body>
      </Card>
    </div>
  );
}
